import {Paginazione} from "../../shared/models/paginazione";

export class RmaFilter extends Paginazione{
  anno?: number;
  mese?: number;
  chiuso?: boolean;
  tipo?: string;
  cliente?: number;
  periodo?: boolean;
  constructor(page, size, anno, mese, chiuso) {
    super(page, size);
    this.chiuso = chiuso;
    this.anno = anno;
    this.mese = mese;
  }
}
